import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=08cd69ea"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cd69ea')) {
      api.createRecord('08cd69ea', component.options)
    } else {
      api.reload('08cd69ea', component.options)
    }
    module.hot.accept("./Features.vue?vue&type=template&id=08cd69ea", function () {
      api.rerender('08cd69ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SystemManage/Features.vue"
export default component.exports